<div class="confirm-container">
  <span mat-dialog-title>Delete Deal</span>
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-12">
        <b>ARE YOU SURE YOU WANT TO DELETE THE DEAL?</b>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h3>Important Deal Information</h3>
        <ul>
          <li>
            <b>ID: </b> {{deal.id}}
          </li>
          <li>
            <b>Name: </b> {{deal.name}}
          </li>
        </ul>
      </div>
    </div>

    <div mat-dialog-actions style="float:right;margin:20px;">
      <button mat-button [mat-dialog-close]="{ clicked: 'Ok'}">Ok</button>
      <button mat-button (click)="onNoClick()">
        Cancel
      </button>
    </div>
  </div>
</div>

